import { getUserPdis } from '@/views/profile/components/pdi/api'
import { getPdiAverage } from '@/views/profile/components/pdi-widget/api'

export default {
    state: {
        pdis: [],
        isLoading: true,
        reloadPDIs: false,
        performance: null,
    },
    mutations: {
        UPDATE_PDIS(state, pdis) {
            state.pdis = pdis
        },
        UPDATE_LOADER(state, value) {
            state.isLoading = value
        },
        RELOAD_PDIS(state, value) {
            state.reloadPDIs = value
        },
        WIDGET_PDIS_PERFORMANCE(state, value) {
            state.performance = value
        },
    },
    actions: {
        updatePdisList({ commit }, { userId, periods = [] }) {
            commit('UPDATE_LOADER', true)
            getUserPdis(userId, periods)
                .then(res => {
                    commit('UPDATE_PDIS', res)
                })
                .finally(() => commit('UPDATE_LOADER', false))
        },
        reloadPDIs({ commit }) {
            commit('RELOAD_PDIS', true)
            setTimeout(() => {
                commit('RELOAD_PDIS', false)
            }, 500)
        },
        getPdisPerformance({ commit }, { userId, periods = [] }) {
            getPdiAverage(userId, periods).then(res => {
                commit('WIDGET_PDIS_PERFORMANCE', res)
            })
        },
    },
}
